// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7256":"bd2b511f","8803":"bd2b511f","8857":"bd2b511f","8931":"bd2b511f"}[chunkId] + ".chunk.css";
};